import React, { useState } from "react";
import { Box, Divider, Tooltip, Zoom, IconButton, Button } from "@mui/material";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CloseOutlined, InfoOutlined, ShoppingCart } from "@mui/icons-material";
import logoMeLi from "../../assets/logoMeLi.svg";
import logoPagotic from "../../assets/logoPagotic.svg";
import logoPVS from "../../assets/pvs-logo.jpg"

export const DrawerPreviewDesktop = ({
  open,
  onClose,
  tarifasSeleccionadas,
  cantidad,
  handleVolver,
}) => {
  const [medioPago, setMedioPago] = useState("mercadopago");

  if (!open) return null;
 
  const subtotal = tarifasSeleccionadas.reduce(
    (acc, t) => acc + (t.cantidad || 0) * (t.precio || 0),
    0
  );

  const comision = tarifasSeleccionadas.reduce(
    (acc, t) =>
      acc +
      (t.cantidad || 0) *
      ((t.precio || 0) * ((t.tipo_comision?.porcentaje ?? 0) / 100)),
    0
  );

  const total = subtotal + comision;

  const hayComision = comision > 0;

  const formatCurrency = (valor) =>
    valor?.toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    });

  return (
    <>
      {/* fondo */}
      <Box
        onClick={onClose}
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          bgcolor: "rgba(0,0,0,0.35)",
          zIndex: 1199,
        }}
      />
      {/* drawer */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          bgcolor: "#fff",
          borderRadius: "10px 10px 0 0",
          boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
          zIndex: 1200,
          minHeight: "40vh",
          maxHeight: "90vh",
          overflowY: "auto",
          p: 0,
          py: 2,
          transition: "transform 0.3s",
        }}
      >
        <Box sx={{ p: 4 }}>
          <Box className="d-flex flex-row justify-content-between">
            <p className="fw-bold mb-3" style={{ color: "#221A60", fontSize: "20px" }}>
              Resumen de tu compra
            </p>
            <IconButton onClick={onClose} size="small">
              <CloseOutlined sx={{ width: "16px", height: "17px" }} />
            </IconButton>
          </Box>
          <Box className="d-flex flex-row w-100">
            <Box sx={{ flex: 1, pr: 3 }}>
              <p style={{ color: "#221A60", fontSize: "20px", marginBottom: "5px" }}>
                Tu compra
              </p>
              <Box className="d-flex flex-column px-3 pt-4">
                <Box className="mb-3">
                  {tarifasSeleccionadas?.length > 0 ? (
                    tarifasSeleccionadas.map((tarifa) => (
                      <Box
                        key={tarifa.id}
                        className="d-flex justify-content-between align-items-center py-1 mb-2"
                      >
                        <Box className="d-flex flex-column">
                          <span>{`${cantidad[tarifa.id]} x ${tarifa.concepto}`}</span>
                        </Box>
                        <span>
                          ${" "}
                          {(tarifa.cantidad * tarifa.precio).toLocaleString("es-ES", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            useGrouping: true,
                          })}
                        </span>
                      </Box>
                    ))
                  ) : (
                    <p className="mb-0">No hay tarifas seleccionadas</p>
                  )}
                </Box>
                {tarifasSeleccionadas?.length > 0 && (
                  <>
                    <Divider variant="middle" sx={{ backgroundColor: "black" }} />
                    <Box className={`d-flex flex-column ${hayComision ? "py-4" : " pt-3"}`}>
                      <Box className="d-flex flex-row justify-content-between">
                        <p className="mb-3">Subtotal</p>
                        <p className="mb-3">$ {formatCurrency(subtotal)}</p>
                      </Box>
                      {hayComision && (
                        <Box className="d-flex flex-row justify-content-between">
                          <Box className="d-flex flex-row align-items-center">
                            <p className="mb-0">Costo</p>
                            <Tooltip
                              arrow
                              TransitionComponent={Zoom}
                              placement="right"
                              title="El costo de servicio de PassGo no es reembolsable"
                            >
                              <InfoOutlined sx={{ width: "18px", height: "18px", marginLeft: "5px" }} />
                            </Tooltip>
                          </Box>
                          <p className="mb-0">$ {formatCurrency(comision)}</p>
                        </Box>
                      )}
                    </Box>
                    <Divider variant="middle" sx={{ backgroundColor: "black" }} />
                    <Box className="d-flex flex-row justify-content-between py-4">
                      <p className="mb-3 fw-bold">Total</p>
                      <Box className="d-flex flex-column text-right">
                        <p className="mb-0 ">
                          $ {formatCurrency(total)}
                        </p>
                        <span className="fw-light" style={{ fontSize: "14px" }}>
                          El precio incluye impuestos
                        </span>
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </Box>
            <Box sx={{ flex: 1, pr: 1 }}>
              <div
                className="d-flex justify-content-between align-items-center px-3 mb-2"
                style={{
                  border: "1px solid #BDBDBD",
                  borderRadius: "4px",
                  backgroundColor: medioPago === 'mercadopago' ? '#f5f5f5' : 'white',
                }}
              >
                <input
                  type="radio"
                  id="mercadopago"
                  name="medioPago"
                  value="mercadopago"
                  checked={medioPago === 'mercadopago'}
                  onChange={(e) => setMedioPago(e.target.value)}
                />
                <label htmlFor="mercadopago" className="mb-0 ml-3">
                  Mercado Pago
                </label>
                <img
                  src={logoMeLi}
                  alt="Logo Mercado Libre"
                  style={{
                    width: "45px",
                    height: "45px",
                    marginLeft: "auto",
                  }}
                />
              </div>
              <div
                className="d-flex justify-content-between align-items-center px-3"
                style={{
                  border: "1px solid #BDBDBD",
                  borderRadius: "4px",
                  backgroundColor: medioPago === 'pagotic' ? '#f5f5f5' : 'white',
                }}
              >
                <input
                  type="radio"
                  id="pagotic"
                  name="medioPago"
                  value="pagotic"
                  checked={medioPago === 'pagotic'}
                  onChange={(e) => setMedioPago(e.target.value)}
                />
                <label htmlFor="pagotic" className="mb-0 ml-3">
                  PagoTIC
                </label>
                <Tooltip
                  title="PagoTIC es una plataforma segura que te permite pagar con tarjeta de crédito, débito o transferencia bancaria"
                  placement="top"
                  arrow
                >
                  <InfoOutlined fontSize="small" style={{ color: '#6c757d', cursor: 'help', marginLeft: "10px" }} />
                </Tooltip>
                <img
                  src={logoPagotic}
                  alt="Logo PagoTic"
                  style={{
                    width: "45px",
                    height: "45px",
                    marginLeft: "auto",
                  }}
                />
              </div>

              <div
                className="d-flex justify-content-between align-items-center px-3 mt-2"
                style={{
                  border: "1px solid #BDBDBD",
                  borderRadius: "4px",
                  backgroundColor: medioPago === 'pvs-link' ? '#f5f5f5' : 'white',
                }}
              >
                <input
                  type="radio"
                  id="pvs-link"
                  name="medioPago"
                  value="pvs-link"
                />
                <label htmlFor="pvs-link" className="mb-0 ml-3">
                  PVS
                </label>
                <Tooltip
                  title="Paga a través de un link seguro con tu tarjeta o escanea un QR con tu billetera virtual"
                  placement="top"
                  arrow
                >
                  <InfoOutlined fontSize="small" style={{ color: '#6c757d', cursor: 'help', marginLeft: "10px" }} />
                </Tooltip>
                <img
                  src={logoPVS}
                  alt="Logo PVS"
                  style={{
                    padding: "5px 0",
                    width: "40px",
                    height: "45px",
                    borderRadius: "50%",
                    marginLeft: "auto",
                  }}
                />
              </div>
              <div
                className="d-flex flex-row justify-content-end align-items-center gap-3"
                style={{ paddingTop: "15px", paddingRight: "10px" }}
              >
                <p className="mb-0" style={{ fontSize: "14px" }}>
                  {format(
                    new Date(),
                    "E. d 'de' MMM. 'de' u HH:mm 'hs'",
                    {
                      locale: es,
                    }
                  )}
                </p>
                <div className="d-flex flex-row align-items-center">
                  <Tooltip
                    arrow
                    TransitionComponent={Zoom}
                    placement="bottom"
                    title="El costo de servicio de PassGo no es reembolsable"
                  >
                    <InfoOutlined
                      sx={{
                        width: "18px",
                        height: "18px",
                        marginRight: "5px",
                      }}
                    />
                  </Tooltip>
                  <p
                    className="mb-0"
                    style={{ fontSize: "18px", fontWeight: "500" }}
                  >
                    $ {total}
                  </p>
                </div>
              </div>
              <p
                style={{
                  fontSize: "14px",
                  paddingTop: "8px",
                  paddingBotton: "15px",
                }}
                className="mb-3"
              >
                Al realizar el pago, acepta las{" "}
                <a href="/legal">Condiciones de servicio de PassGo</a>
              </p>
              <Button
                className="boton-submit w-100"
                fullWidth
                sx={{ mt: 2 }}
                disabled
                startIcon={<ShoppingCart />}
              >
                Finalizar compra
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};